// ─── Story: Image Left ────────────────────────────────────────
// Image on the left, text on the right. Alternating story layout.

import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function StoryImageLeft({ section, data, theme }) {
  const anim = section.animation || {};
  const { title, paragraph, secondaryParagraph, image } = data;
  if (!paragraph && !image) return null;

  return (
    <section className="px-5 py-20 sm:py-24" data-testid="story-section">
      <div className="max-w-2xl mx-auto">
        <AnimatedSection preset={anim.text || 'fade-up'}>
          <p
            className="text-xs tracking-[0.3em] uppercase mb-8 text-center"
            style={{ color: theme.accent, fontFamily: theme.eyebrowFont }}
          >
            {title || 'Our Story'}
          </p>
        </AnimatedSection>

        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Image */}
          {image && (
            <AnimatedSection preset={anim.image || 'slide-right'} className="w-full md:w-1/2 flex-shrink-0">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                <img src={image} alt="" className="w-full h-full object-cover" loading="lazy" />
              </div>
            </AnimatedSection>
          )}

          {/* Text */}
          <AnimatedSection preset={anim.text || 'fade-up'} delay={0.15} className="w-full md:w-1/2">
            <p
              className="text-base sm:text-lg leading-relaxed"
              style={{ color: theme.textPrimary, opacity: 0.85, fontFamily: theme.bodyFont }}
            >
              {paragraph || ''}
            </p>
            {secondaryParagraph && (
              <p
                className="text-sm leading-relaxed mt-4"
                style={{ color: theme.textSecondary, fontFamily: theme.bodyFont }}
              >
                {secondaryParagraph}
              </p>
            )}
          </AnimatedSection>
        </div>

        <AnimatedSection preset="fade-in" delay={0.3}>
          <div className="mt-10 flex justify-center">
            <div className="w-16 h-px" style={{ background: theme.border }} />
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
